﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function CofALauncher() {
    return (
        <div className="launcher-container">
            <h1 className="main-title">CERTIFICATES OF ANALYSIS LAUNCHER</h1>

            <div className="card-container">

                <NavLink className="pw-card-link" to="/certificatesofanalysis">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">summarize</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">C OF A</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/coatools">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">construction</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">C OF A Tools</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/coa-parsing">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">ios_share</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">C OF A Parsing</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">bug_report</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">TESTING</div>
                        </div>
                    </div>
                </NavLink>

            </div>
        </div>
    );
}

